import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
    Box,
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Chip,
    Typography,
} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ProspectIntegrationForm from './ProspectIntegrationForm';

/**
 * Onglet Intégrations — liste d'intégrations sous forme d'accordéon.
 * Chaque intégration = un panneau (résumé + puces de statut dans le summary, formulaire dans les détails).
 * Un seul panneau ouvert à la fois (expanded contrôlé).
 *
 * Ajouter une intégration (ex. e-MECeF, rebasé plus tard depuis feat/emcf-sygmef-normalized-invoice) :
 * déclarer un nouveau panneau <Accordion> en réutilisant le même schéma summary/details, et brancher
 * son propre formulaire (ex. EmcfIntegrationForm) sur le state.settings.integrations.<type>.
 */
class IntegrationsTab extends Component {
    state = {
        // Premier (et seul, en phase 1) panneau ouvert par défaut.
        expanded: 'prospect',
    };

    handleChange = (panel) => (event, isExpanded) => {
        this.setState({ expanded: isExpanded ? panel : false });
    };

    renderStatusChips(integration) {
        const configured = integration && integration.configured;
        const enabled = integration && integration.enabled;
        return (
            <Box display="flex" alignItems="center" style={{ gap: 8 }}>
                <Chip
                    label={configured ? 'Configuré' : 'Non configuré'}
                    size="small"
                    style={{
                        backgroundColor: configured ? '#e8f5e9' : '#fce4ec',
                        color: configured ? '#2e7d32' : '#c62828',
                    }}
                />
                <Chip
                    label={enabled ? 'Actif' : 'Inactif'}
                    size="small"
                    style={{
                        backgroundColor: enabled ? '#e3f2fd' : '#eeeeee',
                        color: enabled ? '#1565c0' : '#616161',
                    }}
                />
            </Box>
        );
    }

    render() {
        const { expanded } = this.state;
        const { prospect } = this.props;

        return (
            <Box>
                <Typography variant="h6" gutterBottom>
                    Intégrations
                </Typography>

                {/* Prospect Energy / NEFCO (reporting RBF) */}
                <Accordion
                    expanded={expanded === 'prospect'}
                    onChange={this.handleChange('prospect')}
                    TransitionProps={{ unmountOnExit: false }}
                >
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                        <Box
                            display="flex"
                            alignItems="center"
                            justifyContent="space-between"
                            width="100%"
                            pr={1}
                            style={{ gap: 16 }}
                        >
                            <Box>
                                <Typography variant="subtitle1" style={{ fontWeight: 600 }}>
                                    Prospect Energy (NEFCO)
                                </Typography>
                                <Typography variant="body2" color="textSecondary">
                                    Envoi quotidien des clients, installations et paiements vers Prospect — reporting RBF.
                                </Typography>
                            </Box>
                            {this.renderStatusChips(prospect)}
                        </Box>
                    </AccordionSummary>
                    <AccordionDetails style={{ display: 'block' }}>
                        <ProspectIntegrationForm />
                    </AccordionDetails>
                </Accordion>

                {/* Futures intégrations (e-MECeF, Odyssey…) : ajouter un <Accordion> ici
                    avec le même schéma (handleChange('<id>'), summary + details). */}
            </Box>
        );
    }
}

function mapStateToProps(state) {
    return {
        prospect: state.settings && state.settings.integrations && state.settings.integrations.prospect,
    };
}

export default connect(mapStateToProps)(IntegrationsTab);
